import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import {Button, Col, FormGroup} from "react-bootstrap";
import Breadcrumbs from '../../../UI/Breadcrumbs';
import * as Api from '../../../../../api/cp/widgetMembers';
import WidgetsList from "../components/WidgetsList";

const WidgetMembersCreator = ({ event }) => {
    const history = useHistory();
    const {widgetKey} = useParams();
    const [widgetsList, setWidgetsList] = useState([]);
    const breadcrumbs = [
        'mainMenu.widgets',
        'mainMenu.schedule.participants',
    ];

    useEffect(fetchScheduleWidgets, [event.eventKey]);

    async function fetchScheduleWidgets() {
        try {
            const response = await Api.getWidgetMembersSettingsList(event.eventKey);
            setWidgetsList(response);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleCreateWidget() {
        try {
            const response = await Api.createWidgetMembers(event.eventKey);
            setWidgetsList((prevState) => ([...prevState, response]));
            history.push(`/event/${event.eventPassword}/widgets/members/edit/${response.widgetKey}`);
        } catch (error) {
            console.error(error);
        }
    };

    function handleEditWidget() {
        history.push(`/event/${event.eventPassword}/widgets/members/edit/${widgetKey}`);
    };

    async function handleDeleteWidget(widgetKey) {
        try {
            await Api.deleteWidgetMembers(widgetKey);
            fetchScheduleWidgets();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <section>
            <Breadcrumbs
                link={`/event/${event.eventPassword}`}
                activeCrumbs={breadcrumbs}
            />

            <Col xs={12}>
                <FormGroup>
                    <Button
                        bsStyle="primary"
                        onClick={handleCreateWidget}
                    >
                        Создать свой виджет
                    </Button>
                </FormGroup>

                <WidgetsList
                    list={widgetsList}
                    onEdit={handleEditWidget}
                    onDelete={handleDeleteWidget}
                />
            </Col>
        </section>
    );
};

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent,
    };
};

export default connect(mapStateToProps)(WidgetMembersCreator);
